import { defineMessages } from 'react-intl-next';

export const messages: {
	closeButton: {
		defaultMessage: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		id: string;
	};
	heading: {
		defaultMessage: string;
		id: string;
	};
	timeoutIconAlt: {
		defaultMessage: string;
		id: string;
	};
} = defineMessages({
	heading: {
		id: 'twc.xflow.modal.timeout.heading',
		defaultMessage: 'Activation is taking longer than expected',
	},
	description: {
		id: 'twc.xflow.modal.timeout.description',
		defaultMessage:
			"Don't worry - we're still working on it. You'll receive an email when your products are ready to use.",
	},
	closeButton: {
		id: 'twc.xflow.modal.timeout.close.button',
		defaultMessage: 'Close',
	},
	timeoutIconAlt: {
		id: 'twc.xflow.modal.timeout.icon.alt',
		defaultMessage: 'Timeout icon',
	},
});


